import requestApi, { get } from '../../../apirest';

export async function fetchConversations(page = 1, limit = 100) {
  const res = await get(`/atendimento/conversations?page=${page}&limit=${limit}`);
  return {
    conversations: res.data?.conversations || [],
    total: res.data?.total ?? 0,
    hasMore: res.data?.hasMore ?? false,
  };
}

export async function fetchMessages(phone) {
  const encoded = encodeURIComponent(phone);
  const res = await get(`/atendimento/messages/${encoded}`);
  return res.data?.messages || [];
}

export async function sendMessage({ phone, body, mediaUrl, mediaContentType }) {
  const res = await requestApi('/atendimento/send', { phone, body, mediaUrl, mediaContentType }, 'post');
  return res.data;
}
